import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';

const appService = {
  ssoLoginByCode(code: string) {
    const params = {
      referer: window.location.href.replaceAll(window.location.hash, ''),
    };
    return axios.post(
      getEndpointBase(`sso/login`),
      {
        code,
      },
      {
        params,
      },
    );
  },
  ssoRefreshToken(refresh_token: string) {
    const params = {
      referer: window.location.href.replace(window.location.hash, ''),
    };
    return axios.post(
      getEndpointBase(`sso/refresh`),
      {
        refresh_token,
      },
      {
        params,
      },
    );
  },
  ssoLogout(refresh_token: string | null) {
    const params = {
      referer: window.location.href.replace(window.location.hash, ''),
    };
    return axios.post(
      getEndpointBase(`sso/logout`),
      {
        refresh_token,
      },
      {
        params,
      },
    );
  }
};

export default appService;
